import * as React from 'react'
import { withRouter, RouteComponentProps, Link } from 'react-router-dom'
import {
  featuresPath,
  pricingPath,
  aboutPath,
  blogPath,
  integrationsPath,
  userLogin,
  Paths,
} from '@logic'
import EquaLogo from '@image/equa-logo-text.svg'
import { HeaderContainer, DesktopNavWrapper, HamburgerButton, MobileNav } from '../styles/marketing.styles'

const navItems = [
  { path: featuresPath, label: 'Features' },
  { path: pricingPath, label: 'Pricing' },
  { path: aboutPath, label: 'About' },
  { path: blogPath, label: 'Blog' },
  { path: integrationsPath, label: 'Integrations' },
]

type Props = RouteComponentProps

const MarketingHeaderComponent: React.FC<Props> = ({ location, history }) => {
  const [mobileOpen, setMobileOpen] = React.useState(false)

  const isActive = (path: string) => location.pathname === path

  return (
    <HeaderContainer>
      <Link to="/" style={{ display: 'flex', alignItems: 'center' }} aria-label="Equa home">
        <EquaLogo style={{ height: 28 }} aria-label="Equa" />
      </Link>
      <DesktopNavWrapper as="nav">
        {navItems.map(({ path, label }) => (
          <Link
            key={path}
            to={path}
            style={{
              color: isActive(path) ? '#33AA40' : 'inherit',
              textDecoration: 'none',
              fontWeight: isActive(path) ? 600 : 500,
              fontSize: '0.875rem',
            }}
          >
            {label}
          </Link>
        ))}
        <Link
          to={userLogin}
          style={{
            marginLeft: '0.5rem',
            padding: '0.5rem 1rem',
            border: '1px solid currentColor',
            borderRadius: 4,
            textDecoration: 'none',
            color: 'inherit',
            fontSize: '0.875rem',
          }}
        >
          Sign In
        </Link>
        <Link
          to={Paths.userRegister}
          style={{
            padding: '0.5rem 1rem',
            background: '#33AA40',
            color: '#fff',
            borderRadius: 4,
            textDecoration: 'none',
            fontSize: '0.875rem',
            fontWeight: 600,
          }}
        >
          Get Started
        </Link>
      </DesktopNavWrapper>
      <HamburgerButton
        type="button"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Toggle menu"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          {mobileOpen ? (
            <path d="M18 6L6 18M6 6l12 12" />
          ) : (
            <>
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </>
          )}
        </svg>
      </HamburgerButton>
      <MobileNav className={mobileOpen ? 'open' : ''}>
        {navItems.map(({ path, label }) => (
          <Link key={path} to={path} onClick={() => setMobileOpen(false)} style={{ color: 'inherit', textDecoration: 'none' }}>
            {label}
          </Link>
        ))}
        <Link to={userLogin} onClick={() => setMobileOpen(false)} style={{ color: 'inherit', textDecoration: 'none' }}>
          Sign In
        </Link>
        <Link to={Paths.userRegister} onClick={() => setMobileOpen(false)} style={{ color: 'inherit', textDecoration: 'none' }}>
          Get Started
        </Link>
      </MobileNav>
    </HeaderContainer>
  )
}

export const MarketingHeader = withRouter(MarketingHeaderComponent)
